import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15.428 10.505a.75.75 0 0 1 1.06 0l3.89 3.889c1.675 1.676 1.961 4.37.094 6.152-1.825 1.74-4.426 1.581-6.127-.12l-3.89-3.889a.75.75 0 1 1 1.062-1.06l3.889 3.889c1.163 1.163 2.833 1.236 4.03.094 1.154-1.1 1.069-2.818-.12-4.005l-3.888-3.89a.75.75 0 0 1 0-1.06M13.5 8.544a.75.75 0 0 0 0-1.06l-3.89-3.89C7.936 1.918 5.242 1.632 3.46 3.5c-1.742 1.825-1.582 4.426.118 6.127l3.89 3.889a.75.75 0 0 0 1.06-1.06L4.64 8.565c-1.163-1.163-1.236-2.834-.094-4.03 1.1-1.154 2.817-1.069 4.005.119l3.89 3.889a.75.75 0 0 0 1.06 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.144 8.063a.75.75 0 0 1 1.061 0l1.944 1.945a.75.75 0 1 1-1.06 1.06L8.144 9.125a.75.75 0 0 1 0-1.06M12.682 12.6a.75.75 0 0 1 1.06 0l1.945 1.945a.75.75 0 1 1-1.06 1.06l-1.945-1.944a.75.75 0 0 1 0-1.06",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }